module.exports = __webpack_public_path__ + "images/harmonie-17580f32b12ceb1631219f5210f3a653.jpg";